import { Guid, isNotNil, Nillable } from '@web/utils';
import { ShippingMethodCode } from '../enums/shipping-method-code';
import { ShippingMethodProperty } from './shipping-method-property';
import { ShippingMethodPropertyCode } from '../enums/shipping-method-property-code';

export class ShippingMethod {
  public constructor(
    private readonly data: {
      id: Guid;
      code: ShippingMethodCode;
      name: string;
      description: string;
      properties: ShippingMethodProperty[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get properties(): ShippingMethodProperty[] {
    return this.data.properties;
  }

  public get isInternationalInPostGeowidget(): boolean {
    if (!this.hasInPostGeowidgetProperty) {
      return false;
    }

    return (
      this.code === ShippingMethodCode.InPostInternationalParcelLocker ||
      this.code === ShippingMethodCode.MondialRelayInternational
    );
  }

  public get isDomesticInPostGeowidget(): boolean {
    if (!this.hasInPostGeowidgetProperty) {
      return false;
    }

    return this.code === ShippingMethodCode.InPostParcelLocker;
  }

  public get inPostGeowidgetProperty(): Nillable<ShippingMethodProperty> {
    return this.properties.find(
      (property) =>
        property.code === ShippingMethodPropertyCode.InPostGeowidget,
    );
  }

  /* prettier-ignore */
  private get hasInPostGeowidgetProperty(): boolean {
    return isNotNil(this.inPostGeowidgetProperty);
  }
}
